/**
 * Created by rhinov10 on 09/05/2016.
 */

import { ActionState, ActionStateEnum } from "..";
import { EntityManager } from "../../plan/EntityManager";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { PlanManager } from "../../../../cocosPlan";
import { ComponentConstants, Entity, Events, eventsManager, Functionality, Listener, math, roomManager } from "@rhinov/savane-js";



export class SelectedOrderRoom extends ActionState {

    state: number = ActionStateEnum.SelectedOrderRoom;
    _previousGridState: boolean = PlanManager.getInstance().scrollWindow.grid._isGridVisible;
    floorChangeListener: Listener | null = null;

    constructor() {
        super();
        PlanManager.getInstance().scrollWindow.grid._isGridVisible = false;
        PlanManager.getInstance().scrollWindow.minzoomindex = 10;
        eventsManager.instance.dispatch(Events.HIDE_BACKGROUND_PRESSED, false);
        this.floorChangeListener = eventsManager.instance.addListener(Events.PLAN_FLOOR_CHANGED, this.lockView.bind(this));
    }

    getAction (): number {
        return ActionStateEnum.SelectedOrderRoom;
    }
    lockView () {
        //Lock grid movement to fit plan
        //PlanManager.getInstance().scrollWindow.centerPosition(true,false);
        //Change room node
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.startVisualiseMode();
            }
        }
    }
    lockViewNoOffset () {
        //Lock grid movement to fit plan
        //PlanManager.getInstance().scrollWindow.centerPosition(true,false);
        eventsManager.instance.dispatch(Events.HIDE_GRID_PRESSED, false);
        //Change room node
        var rooms = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
        for (var i = 0; i < rooms.length; i++) {
            var roomNode = EntityManager.getInstance().getNode(rooms[i]);
            if (roomNode !== null) {
                roomNode.startVisualiseMode();
            }
        }
    }
    moveMouseCursor (cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        super.moveMouseCursor(cursorPosition);
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._mouseDragging(posx, posy, true);
        return null;
    }
    mouseClickDown (cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._startDragging(posx, posy, true);
        return null;
    }
    mouseClickUp (cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        var posx = cursorPosition[0] / 10;
        var posy = cursorPosition[1] / 10;
        PlanManager.getInstance().scrollWindow._endDragging(posx, posy, true);
        var room = roomManager.getRoomAtPosition(cursorPosition, PlanManager.getInstance().world.currentScene!.currentFloor!);
        if (room !== null && !room.isExterior) {
            if ((room.getComponent(ComponentConstants.ComponentType.Functionality) as Functionality).functionalityId !== null) {
                if (room.isOrdered) {
                    room.isOrdered = false;
                    GameObjectManager.drawRoom(room, true, false);
                    eventsManager.instance.dispatch(Events.SELECT_ROOM_FOR_ORDERS, { select_room: room, isSelected: false });
                }
                else {
                    room.isOrdered = true;
                    GameObjectManager.drawRoom(room, false, false);
                    eventsManager.instance.dispatch(Events.SELECT_ROOM_FOR_ORDERS, { select_room: room, isSelected: true });
                }
            }
        }
        //PlanManager.getInstance().updateItemsSelected(null, null, room, null, true, false);
        return null;
    }

    isDecorationState(): boolean {
        return (true);
    }

    dispose () {
        eventsManager.instance.removeListener(this.floorChangeListener!);
    }
}

